import React from 'react';
import { ChevronRight } from 'lucide-react';
import businessMockups from './../assets/HomePage/multi-device.png';
import phoneMockups from './../assets/HomePage/phone_mockup.png';
import { Link } from 'react-router-dom';

const Button = ({ children, className, ...props }) => (
  <button
    className={`
      bg-blue-500 hover:bg-blue-600
      text-white font-medium
      px-8 py-4 text-lg rounded-xl
      inline-flex items-center justify-center
      transform transition-all duration-200
      hover:scale-105 hover:shadow-lg hover:shadow-blue-500/25
      ${className}
    `}
    {...props}
  >
    {children}
  </button>
);

export default function CreditComparison() {
  return (

    <section className=' bg-black'>
    <div className="bg-black text-white py-16 px-4 sm:px-6 md:px-8 lg:px-12 rounded-t-[44px] sm:rounded-t-[36px]">
      <div className="max-w-[90rem] mx-auto">
      <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-5xl xl:text-6xl font-bold text-center mb-5 sm:mb-6 lg:mb-8 text-white">
        Every U.S. business has a credit score, just like individuals have a FICO score. 
        </h2>
        <h2 className="text-2xl text-center mb-8">However, these scores are not connected and should be kept separate. Personal credit impacts personal loans and credit cards, while business credit determines access to financing and resources for growth.</h2>
       
        {/* Personal Credit Section 
        <div className="flex flex-col md:flex-row items-center gap-12 mb-24 group">
          <div className="w-full md:w-3/5 transform transition-all duration-500 group-hover:scale-105">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-500/20 rounded-2xl blur-2xl opacity-50 group-hover:opacity-75 transition-opacity"></div>
              <img
                src={phoneMockups}
                alt="Personal Credit Interface"
                className="w-full max-w-2xl mx-auto relative rounded-2xl shadow-2xl"
              />
            </div>
          </div>
          <div className="w-full md:w-2/5 space-y-6">
            <h2 className="text-3xl font-bold text-white">Personal Credit</h2>
            <p className="text-gray-300 text-lg leading-relaxed">
            Understand and monitor your financial health. Personal credit is calculated using FICO models, which consider factors like payment history, credit utilization, and account length. Tools like Chase Credit Journey, Credit Karma, and Capital One CreditWise provide real-time updates and insights to help you make informed decisions. Your FICO score affects your ability to secure credit cards, auto loans, and mortgages, playing a crucial role in your financial life.
            </p>
          </div>
        </div>

         Business Credit Section 
        <div className="flex flex-col md:flex-row-reverse items-center gap-12 mb-24 group">
          <div className="w-full md:w-3/5 transform transition-all duration-500 group-hover:scale-105">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-500/20 rounded-2xl blur-2xl opacity-50 group-hover:opacity-75 transition-opacity"></div>
              <img
                src={businessMockups}
                alt="Business Credit Interface"
                className="w-full max-w-2xl mx-auto relative rounded-2xl shadow-2xl"
              />
            </div>
          </div>
          <div className="w-full md:w-2/5 space-y-6">
            <h2 className="text-3xl font-bold text-white">Business Credit</h2>
            <p className="text-gray-300 text-lg leading-relaxed">
            Your business’s financial reputation matters. Business credit scores, such as Experian Intelliscore, Equifax OneScore, and Equifax Paynet Masterscore, are calculated based on payment behavior, outstanding debts, and public records. With FuteurAI, the equivalent of Credit Karma for business credit, monitor your scores in real-time, track changes, and get actionable recommendations to enhance your business’s creditworthiness. Empower your business with the tools to access better financing and growth opportunities.
            </p>
          </div>
        </div>

        <div className="text-center transform transition-all duration-500 hover:translate-y-[-4px]">
        <Link to="/credit-comparsion">
          <Button>
            Learn More About the Differences <ChevronRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </div>
      */}
      </div>
    </div>
    </section>
  );
}

